import { NgModule } from '@angular/core';
import { IsGreaterPipe, IsGreaterOrEqualPipe, IsLessPipe, IsLessOrEqualPipe, IsEqualPipe, IsNotEqualPipe, IsIdenticalPipe, IsNotIdenticalPipe, } from './conditions.pipe';
import { IsNullPipe, IsNilPipe, IsUndefinedPipe, IsFunctionPipe, IsNumberPipe, IsStringPipe, IsArrayPipe, IsObjectPipe, IsDefinedPipe } from './types.pipe';
var NgBooleanPipesModule = (function () {
    function NgBooleanPipesModule() {
    }
    return NgBooleanPipesModule;
}());
export { NgBooleanPipesModule };
NgBooleanPipesModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    IsGreaterPipe,
                    IsGreaterOrEqualPipe,
                    IsLessPipe,
                    IsLessOrEqualPipe,
                    IsEqualPipe,
                    IsNotEqualPipe,
                    IsIdenticalPipe,
                    IsNotIdenticalPipe,
                    IsNilPipe,
                    IsNullPipe,
                    IsUndefinedPipe,
                    IsFunctionPipe,
                    IsNumberPipe,
                    IsStringPipe,
                    IsArrayPipe,
                    IsObjectPipe,
                    IsDefinedPipe
                ],
                exports: [
                    IsGreaterPipe,
                    IsGreaterOrEqualPipe,
                    IsLessPipe,
                    IsLessOrEqualPipe,
                    IsEqualPipe,
                    IsNotEqualPipe,
                    IsIdenticalPipe,
                    IsNotIdenticalPipe,
                    IsNilPipe,
                    IsNullPipe,
                    IsUndefinedPipe,
                    IsFunctionPipe,
                    IsNumberPipe,
                    IsStringPipe,
                    IsArrayPipe,
                    IsObjectPipe,
                    IsDefinedPipe
                ]
            },] },
];
/** @nocollapse */
NgBooleanPipesModule.ctorParameters = function () { return []; };
export * from './conditions.pipe';
export * from './types.pipe';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/boolean/index.js
// module id = 257
// module chunks = 103